/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_LightInputs */

const en_directory_submit_badge_light = /** @type {(inputs: Directory_Submit_Badge_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

const zh_directory_submit_badge_light = /** @type {(inputs: Directory_Submit_Badge_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浅色`)
};

/**
* | output |
* | --- |
* | "Light" |
*
* @param {Directory_Submit_Badge_LightInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_light = /** @type {((inputs?: Directory_Submit_Badge_LightInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_LightInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_light(inputs)
	return zh_directory_submit_badge_light(inputs)
});
export { directory_submit_badge_light as "directory.submit.badge_light" }